import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './Navbar.css'
import eye from './eye.png'

function Navbar() {
  const [selectedTabId, setSelectedTabId] = useState("home");

  //set id on click
  const addStatic = (id) => {
    setSelectedTabId(id);
    console.log(selectedTabId);
  }

  //add 'static' class during render
  const addSelected = (id) => {
    if(id === selectedTabId) {
      return "static";
    } else {
      return "";
    }
  };
  
  function NavLink(props) {
    return (
      <Link onClick={() => addStatic(props.id)} className={`aphant ${props.pic && 'pic'} ${addSelected(props.id)}`} to={(props.page)} id={props.id}>
          {props.pic && <img className="logo" alt="aphantasia eye symbol" src={props.pic}/>}
          {props.text}
      </Link>
    )
  }

  return (
    <nav className="header-nav">
      <title>{selectedTabId!=='home' && `${selectedTabId} - `}Closed Eyes Arg Official WebSight</title>
      <NavLink
        id='home' page=''
        pic={eye}
      />
      <NavLink id='Characters' page='characters' text='Characters'/>
      <NavLink id='Dream' page='dream' text='Dream'/>
      <NavLink id='Ink' page='ink-and-shards' text='Ink & Shards'/>
    </nav>
  )
}

export default Navbar